export default "__VITE_ASSET__60769cd9__"